// @ts-strict

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';

/**
 * @ngModule CoreModule
 * @description
 *
 * Service responsible for sharing toggle sidebar status throughout the components
 */
@Injectable({
  providedIn: 'root'
})
export class ToggleSidebarService {
  toggleStatus = false;
  getToggleStatus = new Subject<boolean>();
  public mediumScreenSize = false;
  public largeScreenSize = false;

  constructor(private breakpointObserver: BreakpointObserver) {}

  public toggleSidebar(status?: boolean): void {
    if (typeof status !== 'undefined') {
      this.toggleStatus = status;
    } else {
      if (this.mediumScreenSize) {
        this.toggleStatus = true;
      } else {
        this.toggleStatus = !this.toggleStatus;
      }
    }
    this.getToggleStatus.next(this.toggleStatus);
  }

  /**
   * Checks for screen size. If it is more than 768px and less than 1200px, sidebar is automatically collapsed
   */
  public checkScreenSize(): void {
    this.breakpointObserver
      // .observe(['(min-width: 768px) and (max-width: 1199px)'])
      .observe(['(min-width: 1200px) and (max-width: 1367px)'])
      .subscribe(result => {
        if (result.matches) {
          // to respect that conditions upstairs just change mediumScreenSize and toggleSidebar below for true
          this.mediumScreenSize = false;
          this.largeScreenSize = true;
          this.toggleSidebar(true);
        } else {
          this.mediumScreenSize = false;
          this.toggleSidebar(false);
        }
      });
  }

  public getToggleStatusFunction(): boolean {
    return this.toggleStatus;
  }
}
